function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Shape");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Web",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Patient-Portal-Signed-In-//-Documents",
  transform: "translate(-761.000000, -359.000000)",
  fill: "#31CC97",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(761.000000, 355.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.3333333,6.16666667 L9.85,6.16666667 C9.5,5.2 8.58333333,4.5 7.5,4.5 C6.41666667,4.5 5.5,5.2 5.15,6.16666667 L1.66666667,6.16666667 C0.75,6.16666667 0,6.91666667 0,7.83333333 L0,19.5 C0,20.4166667 0.75,21.1666667 1.66666667,21.1666667 L13.3333333,21.1666667 C14.25,21.1666667 15,20.4166667 15,19.5 L15,7.83333333 C15,6.91666667 14.25,6.16666667 13.3333333,6.16666667 Z M7.5,6.16666667 C7.95833333,6.16666667 8.33333333,6.54166667 8.33333333,7 C8.33333333,7.45833333 7.95833333,7.83333333 7.5,7.83333333 C7.04166667,7.83333333 6.66666667,7.45833333 6.66666667,7 C6.66666667,6.54166667 7.04166667,6.16666667 7.5,6.16666667 Z M5.24166667,17.2416667 L3.08333333,15.0833333 C2.75833333,14.7583333 2.75833333,14.2333333 3.08333333,13.9083333 C3.40833333,13.5833333 3.93333333,13.5833333 4.25833333,13.9083333 L5.83333333,15.475 L10.7333333,10.575 C11.0583333,10.25 11.5833333,10.25 11.9083333,10.575 C12.2333333,10.9 12.2333333,11.425 11.9083333,11.75 L6.41666667,17.2416667 C6.1,17.5666667 5.56666667,17.5666667 5.24166667,17.2416667 Z",
  id: "Shape"
}))));

var SvgCompleted = function SvgCompleted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "18px",
    viewBox: "0 0 15 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompleted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/completed.9a935d11.svg";
export { ForwardRef as ReactComponent };